import React from "react";
import { Box, Typography } from "@mui/material";

export default function ShippingPolicy() {
  return (
    <Box sx={{ direction: "rtl", p: 4, textAlign: "center" }}>
      <Typography variant="h5" sx={{ mb: 2 }}>
        תקנון משלוחים
      </Typography>

      <Typography variant="h4" sx={{ fontWeight: "bold", mb: 1 }}>
        כרגע משלוחים הם בירושלים והסביבה בלבד
      </Typography>

      <Typography variant="h6" sx={{ mb: 2 }}>
        מחירון משלוחים
      </Typography>

      <Box
        sx={{
          width: "80%",
          maxWidth: 700,
          mx: "auto",
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          border: "1px solid black",
          mb: 4,
        }}
      >
        {[
          "בירושלים מעל 600 שקל חינם",
          "בירושלים בקניה בין 300-600 עלות של 35 שקל",
          "גילה, גבעת זאב, הר חומה ותלפיות בקניה מעל 600 שקל עלות של 25 שקל",
          "גילה, גבעת זאב, הר חומה ותלפיות בקניה בין 300-600 עלות של 50 שקל",
          "תל ציון, טלסטון, ומעלה אדומים בקניה מעל 600 שקל עלות של 35 שקל",
          "תל ציון, טלסטון, ומעלה אדומים בקניה בין 300-600 עלות של 50 שקל",
        ].map((text, index) => (
          <Box
            key={index}
            sx={{
              minHeight: 120,
              border: "1px solid black",
              p: 1,
              fontSize: 18,
            }}
          >
            {text}
          </Box>
        ))}
      </Box>

     <Typography
  sx={{
    mb: 1,
    fontSize: { xs: "18px", md: "22px" },
    fontWeight: 500,
  }}
>
  מחירי המוצרים המופיעים באתר אינם כוללים דמי משלוח
</Typography>

<Typography
  sx={{
    mb: 1,
    fontSize: { xs: "18px", md: "22px" },
    fontWeight: 500,
  }}
>
  איסוף עצמי יתבצע לאחר תיאום עם נציג בחנות ואישור שההזמנה מוכנה
</Typography>

<Typography
  sx={{
    fontSize: { xs: "18px", md: "22px" },
    fontWeight: 500,
  }}
>
  המשלוח יסופק עד 7 ימי עסקים
  על ידי חברת שליחויות
</Typography>
    </Box>
  );
}